<template>
    <project-step-container
            prev-to="js_go_broad_to_go_narrow_10"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="pb-5">
            <b-col cols="12" class=" simple-text" tabindex="0">
                 {{getMessage(11, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>

        <LinkStyleGuide @open-url="openGuide100Narrowing" icon-name="icon-guide" :text="getMessage(11, 'gobroadtogonarrow-guide')" ></LinkStyleGuide>
        <br>
        <LinkStyleGuide @open-url="openGuide2By2Narrowing" icon-name="icon-guide" :text="getMessage(11, 'gobroadtogonarrow-guide-2')" ></LinkStyleGuide>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {Steps} from "@/modules/JobShadow/Utils";

    export default {
        name: "DeepCustomerEmpathy11",
        components: {ProjectStepContainer,LinkStyleGuide, ProjectStyleGuide },
        data() {
            return {
                step:Steps.FORM_JS_BROAD_NARROW_GOING_EVEN,
                styleGuide: {}
            }
        },
        methods: {
            openGuide100Narrowing() {
                this.styleGuide = StyleGuides.getStyleGuide(StyleGuides.POINTS_NARROWING)
                this.$bvModal.show('project-style-guide')
            },
            openGuide2By2Narrowing() {
                this.styleGuide = StyleGuides.getStyleGuide(StyleGuides.NARROWING)
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'js_go_broad_to_go_narrow_12', params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .simple-text-second
        font font-sourcesans-bold
        font-size 14px
        color color-4
</style>

